import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from '@bwoty-web/ui-kit';

import './skipLink.scss';

const SkipLink = ({ href, linkText, className = '' }) => {
  if (!href || !linkText) return undefined;

  return (
    <Link
      href={href}
      className={classNames('skipLink', className)}
    >
      {linkText}
    </Link>
  );
};

SkipLink.propTypes = {
  href: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default SkipLink;
